<template>
  <dialog ref="dialog">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <p class="my-4">
            <slot />
          </p>

          <div class="row">
            <button
              size="sm"
              class="btn btn-outline-secondary rg-border-radius mx-auto"
              type="button"
              @click="clickAcknowledge"
            >
              {{ acknowledge }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
  import dialogPolyfill from 'dialog-polyfill';

  export default {
    props: {
      acknowledge: {
        default: 'Acknowledge',
        required: false,
        type: String
      }
    },

    mounted () {
      if (typeof HTMLDialogElement !== 'function') {
        dialogPolyfill.registerDialog(this.$refs.dialog);
      }
    },

    methods: {
      clickAcknowledge () {
        this.$emit('acknowledged');
      },
      show () {
        this.$refs.dialog.setAttribute('open', '');
        this.$refs.dialog.show();
      },
      close () {
        this.$refs.dialog.close();
      }
    }
  };
</script>
